import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';
import { SKIP_ERROR_NOTIFICATION } from '@core/error-handling/services/http-error-notification.interceptor';

export interface HoraAulaItemDuracao {
  nroAula?: number;
  numero?: number;
  turnos?: string[];
}

export interface HoraAulaItem {
  diasDaSemana?: Array<string | number>;
  itensDuracao?: HoraAulaItemDuracao[];
}

export interface HoraAulaResponse {
  itens?: HoraAulaItem[];
}

@Injectable({
  providedIn: 'root'
})
export class HoraAulaService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Legacy: Restangular.all('professores/horas-aulas').one('turma', turmaId).get('')
   */
  async getHoraAulasTurma(turmaId: number): Promise<HoraAulaResponse | null> {
    const ctx = new HttpContext().set(SKIP_ERROR_NOTIFICATION, true);
    const url = `${this.apiUrl}/professores/horas-aulas/turma/${turmaId}`;

    try {
      const result = await firstValueFrom(
        this.http.get<HoraAulaResponse | HoraAulaResponse['itens']>(url, { context: ctx })
      );

      if (Array.isArray(result)) {
        return { itens: result as HoraAulaItem[] };
      }

      return result ?? null;
    } catch {
      return null;
    }
  }
}

